var _ellipse, _rect, _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackerEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 130,
    viewBox: "0 0 180 130",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 115,
    rx: 60,
    ry: 7,
    fill: "#EDF2F7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 12,
    width: 82,
    height: 96,
    rx: 8,
    fill: "#F5F8FC",
    stroke: "#B9CADD",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 34h48M61 47h38M61 60h28",
    stroke: "#B9CADD",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 84,
    r: 23,
    fill: "#FFF5D6",
    stroke: "#D6B45B",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 81,
    r: 10,
    stroke: "#062158",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m125 89 9 9",
    stroke: "#062158",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackerEmpty);
export default __webpack_public_path__ + "static/media/tracker-empty.05b1d8efe37cd677de33b5ba49b80c14.svg";
export { ForwardRef as ReactComponent };